<template>
    <div>
      <h2>作业上传</h2>
      <input type="file" @change="handleFileChange">

      <el-button @click="uploadFile">上传</el-button>
      <el-button type="primary" @click="back">返回</el-button>
    </div>
  </template>

<script>
export default {
  name: 'UploadComponent',
  data() {
    return {
      selectedFile: null
    }
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0]
    },
    back() {
      this.$router.push('/homework')
    },
    uploadFile() {
      if (this.selectedFile) {
        // 这里可以添加实际的上传逻辑，例如调用 API 上传文件
        console.log('上传文件:', this.selectedFile)
      } else {
        this.$message.warning('请选择要上传的文件')
      }
    }
  }
}
</script>
